// 异步操作,提交改变后的状态
import axios from "axios";
// import qiniu from 'qiniu';
const actions = {};

export default actions;
